import {ApplicationRef, Component, Input, OnInit} from '@angular/core';
import {ClassroomAction, ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {AssignmentState, AssignmentStateModel} from '@app/state/assignment.state';
import {ViewportTab} from '@app/modules/shared/data/constants';
import {LocalUserAction} from '@app/state/local-user.state';
import {WhiteboardService} from '@app/modules/whiteboard/services/whiteboard.service';

@Component({
  selector: 'app-observer-toolbar',
  templateUrl: './observer-toolbar.component.html',
  styleUrls: ['./observer-toolbar.component.css']
})
export class ObserverToolbarComponent implements OnInit {
  public classroom: ClassroomStateModel;
  public assignment: AssignmentStateModel;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ViewportTab = ViewportTab;

  @Input()
  public whiteboardService: WhiteboardService;

  constructor(
    private applicationRef: ApplicationRef,
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  ngOnInit(): void {}

  public switchViewPortTab(viewportTab: ViewportTab): void {
    this.store.dispatch(new ClassroomAction.SetBoardTab(viewportTab));
    this.store.dispatch(new LocalUserAction.SetCurrentTab(viewportTab));
    this.applicationRef.tick(); /* force update ui to make whiteboard wrapper visible */
    this.whiteboardService.updateGrid();
    this.whiteboardService.updateScroll();
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.store.select(AssignmentState).subscribe((assignment: AssignmentStateModel) => {
      this.assignment = assignment;
    });
  }
}
